export default __webpack_public_path__ + "static/media/switch1.d950a4fc.svg";